import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { RichText } from "../../components/Generic/RichText/RichText/RichText"

/**
 * Props for `TextBlock`.
 */
export type TextBlockProps = SliceComponentProps<Content.TextBlockSlice>

/**
 * Component for "TextBlock" Slices.
 */
const TextBlock = ({ slice }: TextBlockProps): JSX.Element => {
  const { content_id } = slice.primary
  const id = content_id || undefined

  return <RichText field={slice.primary.content} id={id} />
}

export default TextBlock
